var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.tag, { tag: "component", staticClass: "ui-focus-container" }, [
    _vm.renderRedirector
      ? _c("span", {
          staticClass: "ui-focus-container-focus-redirector",
          attrs: { tabindex: "0" },
          on: {
            focus: function ($event) {
              return _vm.redirectFocus($event, { isTabbingForward: false })
            },
          },
        })
      : _vm._e(),
    _c(
      "div",
      {
        ref: "content",
        staticClass: "ui-focus-container-content",
        attrs: { tabindex: "-1" },
      },
      [_vm._t("default")],
      2
    ),
    !_vm.disabled && _vm.containFocus
      ? _c("span", {
          ref: "lastFocusable",
          staticClass: "ui-focus-container-last-focusable",
          attrs: { tabindex: "-1" },
        })
      : _vm._e(),
    _vm.renderRedirector
      ? _c("span", {
          staticClass: "ui-focus-container-focus-redirector",
          attrs: { tabindex: "0" },
          on: {
            focus: function ($event) {
              return _vm.redirectFocus($event, { isTabbingForward: true })
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }